(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azzaro-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection;
    var saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
    if (reduce || saveData) return;

    function start(v) {
      if (v.dataset.src && !v.src) v.src = v.dataset.src;
      var p = v.play();
      if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
      else v.classList.add('is-playing');
    }

    function init(root) {
      var vids = root.querySelectorAll('.az-insta__video');
      if (!vids.length) return;
      if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) start(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { rootMargin: '150px 0px', threshold: 0.3 });
      vids.forEach(function (v) { io.observe(v); });
    }

    function boot() { document.querySelectorAll('[data-az-insta]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-az-insta]');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azzaro-video-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Play a tile's video only while it is on screen. Nothing downloads
    // before that: every <video> ships with preload="none", and URL-only
    // videos carry their address in data-src until they are needed.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection;
    var saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
    if (reduce || saveData) return;

    function start(v) {
      if (v.dataset.src && !v.src) v.src = v.dataset.src;
      var p = v.play();
      if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
      else v.classList.add('is-playing');
    }

    function init(root) {
      var vids = root.querySelectorAll('.az-vsplit__video');
      if (!vids.length) return;
      if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) start(v);
          else if (!v.paused) v.pause();
        });
      }, { rootMargin: '200px 0px', threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    }

    function boot() { document.querySelectorAll('[data-az-vsplit]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    // Re-run when the theme editor re-renders a section.
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-az-vsplit]');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const sectionId = this.getAttribute('section-id');
      const image = this.querySelector('img');
      const aosAnimation = this.getAttribute('data-aos');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.parallaxEffect);
          } else {
            window.removeEventListener('scroll', this.parallaxEffect);
          }
        });
      });

      const section = document.getElementById(sectionId);
      observer.observe(section);

      const imageContainer = this;
      imageContainer.style.transform = 'translateY(0)';

      this.parallaxEffect = () => {
        const scrollPosition = window.pageYOffset;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const parallaxValue = (scrollPosition / maxScroll) * 50;
        image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
      };
    }
  }

  customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
class QuotesCarousel extends HTMLElement {
  connectedCallback() {
    this.slidesToShow  = Math.max(1, parseInt(this.dataset.slidesToShow) || 1);
    this.infinite      = this.dataset.infinite !== 'false';
    this.draggable     = this.dataset.draggable !== 'false';
    this.hasDots       = this.dataset.dots !== 'false';
    this.track         = this.querySelector('.quotes-slider');
    this.slides        = Array.from(this.track.children);
    this.total         = this.slides.length;
    this.current       = 0;
    this.slideWidth    = 0;

    if (this.total <= this.slidesToShow) {
      // Hide arrows/dots when no scrolling needed
      this.querySelectorAll('.quotes-arrow').forEach(b => b.style.display = 'none');
      this.querySelectorAll('.quotes-dots').forEach(d => d.style.display = 'none');
      return;
    }

    this._buildDots();
    this._bindArrows();
    if (this.draggable) this._bindDrag();
    window.addEventListener('resize', () => this._goTo(this.current, false));
    requestAnimationFrame(() => this._goTo(0, false));
  }

  _slideWidth() {
    return this.track.parentElement.offsetWidth / Math.min(this.slidesToShow, this.total);
  }

  _goTo(index, animate = true) {
    const sw = this._slideWidth();
    if (!animate) this.track.style.transition = 'none';
    else this.track.style.transition = 'transform 0.4s ease';

    if (this.infinite) {
      this.current = ((index % this.total) + this.total) % this.total;
    } else {
      this.current = Math.max(0, Math.min(index, this.total - this.slidesToShow));
    }

    this.track.style.transform = `translateX(-${this.current * sw}px)`;
    this._updateDots();

    if (!animate) requestAnimationFrame(() => this.track.style.transition = 'transform 0.4s ease');
  }

  _buildDots() {
    if (!this.hasDots) return;
    const dotsEl = this.querySelector('.quotes-dots');
    if (!dotsEl) return;
    const pages = this.infinite ? this.total : Math.ceil(this.total / this.slidesToShow);
    dotsEl.innerHTML = '';
    for (let i = 0; i < pages; i++) {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
      btn.addEventListener('click', () => this._goTo(i * (this.infinite ? 1 : this.slidesToShow)));
      li.appendChild(btn);
      dotsEl.appendChild(li);
    }
    this._updateDots();
  }

  _updateDots() {
    const dotsEl = this.querySelector('.quotes-dots');
    if (!dotsEl) return;
    const btns = dotsEl.querySelectorAll('button');
    const activePage = this.infinite ? this.current : Math.floor(this.current / this.slidesToShow);
    btns.forEach((b, i) => b.classList.toggle('active', i === activePage));
  }

  _bindArrows() {
    const prev = this.querySelector('.quotes-arrow--prev');
    const next = this.querySelector('.quotes-arrow--next');
    if (prev) prev.addEventListener('click', () => this._goTo(this.current - (this.infinite ? 1 : this.slidesToShow)));
    if (next) next.addEventListener('click', () => this._goTo(this.current + (this.infinite ? 1 : this.slidesToShow)));
  }

  _bindDrag() {
    let startX = 0, isDragging = false;
    this.track.addEventListener('mousedown', e => { startX = e.clientX; isDragging = true; });
    this.track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
    const end = (endX) => {
      if (!isDragging) return; isDragging = false;
      const diff = startX - endX;
      if (Math.abs(diff) > 40) this._goTo(this.current + (diff > 0 ? 1 : -1));
    };
    this.track.addEventListener('mouseup',   e => end(e.clientX));
    this.track.addEventListener('touchend',  e => end(e.changedTouches[0].clientX));
    this.track.addEventListener('mouseleave', e => { if (isDragging) end(e.clientX); });
  }
}
customElements.define('quotes-carousel', QuotesCarousel);

  } catch(e) { console.error(e); }
})();
})();
